import { useEffect } from 'react';
import { View, Platform } from 'react-native';
import { useRouter } from 'expo-router';
import * as Linking from 'expo-linking';
import { Screen } from '@/components/layout/Screen';
import { Button } from '@/components/ui/Button';
import { Body, Caption, SubHeading } from '@/components/ui/Text';
import { useTheme } from '@/theme';
import { getEmailVerifiedContinueUrl } from '@/utils/emailVerificationActionSettings';

const PAGE_TITLE = 'Email verified — Tripvio';

export default function EmailVerifiedScreen() {
  const theme = useTheme();
  const router = useRouter();
  const openAppBase = getEmailVerifiedContinueUrl().replace(/\/auth\/email-verified\/?$/, '');

  useEffect(() => {
    if (Platform.OS === 'web' && typeof document !== 'undefined') {
      document.title = PAGE_TITLE;
    }
  }, []);

  return (
    <Screen title="You’re verified" subtitle="Your email address is confirmed. You can continue in Tripvio.">
      <View style={{ gap: theme.spacing(2) }}>
        <Body color={theme.colors.textSecondary}>
          If you signed up on your phone, return to the Tripvio app. If you use Tripvio in the browser, open the web
          app below.
        </Body>
        <SubHeading style={{ marginTop: theme.spacing(0.5) }}>Open Tripvio</SubHeading>
        <Button
          label="Open web app"
          onPress={() => {
            void Linking.openURL(openAppBase);
          }}
        />
        <Button
          label="Sign in in this browser"
          variant="secondary"
          onPress={() => {
            router.replace('/(onboarding)/sign-in');
          }}
        />
        <Caption color={theme.colors.textSecondary}>
          This page is the post-verification landing URL ({getEmailVerifiedContinueUrl()}) for Firebase email actions.
        </Caption>
      </View>
    </Screen>
  );
}
